<template>
  <div class="page-login">
    <div class="login">
      <!-- <div class="logo">
                <img
                    :src="logo"
                    alt=""
                >
            </div> -->

      <div class="box">
        <form class="form" @submit.prevent="veeFormSubmit">
          <div class="header">
            <!-- <div class="title-top"><img :src="logo" alt=""></div> -->
            <div class="title-top">
              <img src="/img/login/hx-logo.png" alt="" />
            </div>
            <!-- <div class="title">{{title}}</div> -->
            <!-- <div class="desc">welcome to login system</div> -->
          </div>

          <div>
            <div class="tips" v-if="error.length > 0">
              <img src="/img/login/tip2.png" alt="" />
              <span>{{ error }}</span>
            </div>
            <xc-form-item
              class="form-item"
              label=""
              hideError
              :error="errors.first('userName')"
            >
              <div class="icon">
                <img src="/img/login/icon-username3.png" />
              </div>
              <input
                v-validate="'required'"
                data-vv-as="账号"
                name="userName"
                type="text"
                class="xc-input login-input"
                placeholder="请输入用户名"
              />
            </xc-form-item>
            <xc-form-item label="" hideError :error="errors.first('password')">
              <div class="icon">
                <img src="/img/login/icon-password3.png" />
              </div>
              <input
                v-validate="'required'"
                data-vv-as="密码"
                type="password"
                name="password"
                class="xc-input"
                placeholder="请输入密码"
              />
            </xc-form-item>
            <!-- <xc-form-item
                        label="验证码"
                        class="code"
                        >
                        <input
                            type="text"
                            class="xc-input"
                            placeholder="请输入验证码"
                            name="imageCode"
                        >
                        <img
                            :src="codeImg"
                            class="image-code"
                        >
                        </xc-form-item> -->
            <xc-form-item>
              <button class="btn-login xc-btn-l xc-btn-primary">登录</button>
            </xc-form-item>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
import "@/utils/form-format"; // 表单格式化
import loadScript from "../utils/load-script";
import loginApi from "../api/login";
import "@/libs/vee-validate";
import { mapState, mapActions } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      index: null,
      // 验证码
      // codeImg: this.$config.apiUrl + '/image/code?width=66&height=26&key=superadmin',
      error: "",
      // logo: '/img/login/tip.png'
    };
  },
  async created() {
    await loadScript("/libs/md5.js");

    // 强制跳出iframe
    if (top.location != location) {
      top.location.href = location.href;
    }
  },
  mounted() {},
  computed: {
    ...mapState(["globalConfig"]),
    title() {
      if (
        this.globalConfig.platform_name &&
        this.globalConfig.platform_name.value
      ) {
        return this.globalConfig.platform_name.value;
      }

      return null;
    },
    logo() {
      if (this.globalConfig.logo_url && this.globalConfig.logo_url.value) {
        return this.globalConfig.logo_url.value;
      }

      return null;
    },
  },
  methods: {
    // vee表单验证
    veeFormSubmit(e) {
      let that = this;

      this.$validator.validateAll().then((validate) => {
        if (validate) {
          const data = this.$formFormat(e.target);

          loginApi(data.userName, window.md5(data.password))
            .then((v) => {
              this.$message.success("登录成功");
              localStorage.token = v.data.token;

              let backUrl = this.$route.query.backUrl;
              if (backUrl) {
                backUrl = decodeURIComponent(backUrl);
              } else {
                const menuList = v.data.menu;

                let indexUrl;
                if (menuList[0].children && menuList[0].children.length) {
                  indexUrl = menuList[0].children[0].url;
                  localStorage.pageId = menuList[0].children[0].moduleId;
                  localStorage.pageParentId = menuList[0].children[0].pid;
                } else {
                  indexUrl = menuList[0].url;
                  localStorage.pageId = menuList[0].moduleId;
                  localStorage.pageParentId = menuList[0].pid;
                }

                backUrl = process.env.VUE_APP_ADMIN_PATH + indexUrl;
              }

              setTimeout(() => {
                location.href = backUrl;
              }, 500);
            })
            .catch((e) => {
              that.error = e[0];
            });
          return;
        } else {
          this.error = "账号密码不能为空";
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page-login {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: url("/img/login/hxmkl-bg.jpg") #060b11 no-repeat;
  background-size: cover;
}

.logo {
  text-align: center;
  margin-bottom: 32px;
  margin-top: -60px;
  img {
    width: 168px;
  }
}

.tips {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #ffba00;
  width: 100%;
  margin-bottom: 8px;
  // position: absolute;
  // left: 50%;
  // transform: translateX(-50%);
  // top:95px;
  // justify-content: center;
  img {
    height: 16px;
    width: 16px;
    margin-right: 6px;
  }
}

.btn-login {
  width: 400px !important;
  height: 60px !important;
  line-height: 60px;
  background-color: #006ebc;
  border-radius: 8px !important;
  word-spacing: 8px;
  margin-top: 20px;
}

// .code {
//     position: relative;
//     .image-code {
//         position: absolute;
//         right: -72px;
//         top: 3px;
//     }
// }

.box {
  // background: url(/img/login/login-bg3.png) center center no-repeat;
  width: 454px;
  height: 470px;
  position: relative;
  margin-right: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  form {
    // position: absolute;
    // left: 64px;
    // top: 40px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header {
    margin-bottom: 60px;
    text-align: center;
    .title-top {
      img {
        width: 494px;
        height: 164px;
      }
    }
    .title {
      font-size: 32px;
      line-height: 32px;
      color: #ffffff;
      font-weight: bold;
      margin-top: 30px;
      opacity: 0.7;
    }
    .desc {
      font-size: 14px;
      color: #ffffff;
      opacity: 0.2;
    }
  }
}
</style>

<style lang="scss">
.page-login {
  .xc-form-item {
    margin-bottom: 20px;
  }
  .xc-form-item-label {
    display: none;
  }
  .xc-form-item-content {
    position: relative;
    line-height: 38px;

    .icon {
      position: absolute;
      left: 0;
      top: 12px;
      margin-left: 12px;
      img {
        vertical-align: text-top;
        width: 20px;
      }
    }

    input {
      width: 400px !important;
      height: 60px !important;
      padding-left: 44px !important;
      line-height: 60px !important;
      font-size: 20px;
      border: solid 1px #043996;
      background: #203a9c;
      background-color: #062581;
      color: #ffffff;
      border-radius: 8px;
    }
    ::-webkit-input-placeholder {
      color: rgba(255, 255, 255, 0.3);
    } /* 使用webkit内核的浏览器 */
    :-moz-placeholder {
      color: rgba(255, 255, 255, 0.3);
    } /* Firefox版本4-18 */
    ::-moz-placeholder {
      color: rgba(255, 255, 255, 0.3);
    } /* Firefox版本19+ */
    :-ms-input-placeholder {
      color: rgba(255, 255, 255, 0.3);
    }

    .xc-input:focus {
      border: 1px solid #0075c8;
    }

    //消除google浏览器黄色框
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus {
      box-shadow: 0 0 0 60px #062581 inset;
      -webkit-text-fill-color: #5b6aa7;
      font-size: 20px;
    }

    .login-input {
      line-height: 50px;
    }
  }
}
</style>
